import BaseApi from './BaseApi'

class AdviserContactApi extends BaseApi {
  get adviserContactUrl () {
    return 'adviserContact'
  }
  get sentEmailsUrl () {
    return 'sentEmails'
  }

  postAdviserContact (adviserContact) {
    return this.postJson(this.adviserContactUrl, adviserContact)
  }

  getSentEmails (sentEmails) {
    return this.getJson(`${this.sentEmailsUrl}/${sentEmails.fromEmailAddress}`)
  }

  postSentEmail (sentEmail) {
    return this.postJson(`${this.sentEmailsUrl}/storeEmail`, sentEmail)
  }
}

export default AdviserContactApi
